import React from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { BillingInvoicesRoute, BillingPaymentDetailsRoute, BillingPendingRoute } from '~/lib/helper/RouteHelper';

interface CancelBlurbProps {
    invoiceId?: string;
    returnUrl?: string;
    forSignup?: boolean;
}

export function CancelBlurb(props: CancelBlurbProps) {
    return (
        <div>
            <h3>Payment Cancelled</h3>
            <Card className="mt-4">
                <CardBody>
                    <p>Your PayPal payment request was cancelled.</p>
                    {!props.forSignup && (
                        <>
                            <p>
                                To change your billing method or to confirm your PayPal account, please visit{' '}
                                <a href={BillingPaymentDetailsRoute}>Edit Billing Details</a>.
                            </p>
                            <p>
                                If you want to add credit to your account please visit the{' '}
                                <a href={BillingPendingRoute}>Account Balance</a> page.
                            </p>
                        </>
                    )}

                    <Button color="primary" href={props.returnUrl ?? BillingInvoicesRoute}>
                        {props.forSignup ? 'Back to Signup' : 'Continue'}
                    </Button>
                </CardBody>
            </Card>
        </div>
    );
}
